import { Pipe, PipeTransform } from '@angular/core';
import {CompetitorResults, CompetitorStageDetail, MeasurementTypes} from '@model';

@Pipe({
    name: 'rank',
    standalone: false
})
export class ResultsRankPipe implements PipeTransform {
  transform(competitor: CompetitorResults|CompetitorStageDetail|undefined, category?: number, gender?: number, measurementType?: MeasurementTypes, isForDetails: boolean = false, fallbackStatus: boolean = false): string {
    if (!competitor) return '-'
    if (isForDetails) {
      const rank = this.getRankByStage(competitor as CompetitorStageDetail, category, gender);
      return rank !== 0 && rank !== undefined && rank !== null ? rank.toString() : "-";
    } else {
      const rank = measurementType === MeasurementTypes.CHIP_TIME_ONLY || measurementType === MeasurementTypes.CHIP_TIME_PRIMARY
        ? this.getChipRank(competitor as CompetitorResults, category, gender)
        : this.getRank(competitor  as CompetitorResults, category, gender);
      return rank !== 0 && rank !== undefined && rank !== null ? rank.toString() : this.fallBack(competitor as CompetitorResults, fallbackStatus);
    }
  }

  private getChipRank(competitor: CompetitorResults, category?: number, gender?: number): number | undefined {
    if (!category && !gender) return competitor.chipAbsoluteRank;
    if (!category && gender) return competitor.chipSexRank;
    return competitor.chipCategoryRank;
  }

  private getRank(competitor: CompetitorResults, category?: number, gender?: number): number | undefined {
    if (!category && !gender) return competitor.absoluteRank;
    if (!category && gender) return competitor.sexRank;
    return competitor.categoryRank;
  }

  private getRankByStage(competitorStageDetail: CompetitorStageDetail, category?: number, gender?: number): number | undefined {
    if (!category && !gender) return competitorStageDetail.abrk;
    if (!category && gender) return competitorStageDetail.sxrk;
    return competitorStageDetail.ctrk;
  }

  private fallBack(competitor: CompetitorResults, assignStutus: boolean): string {
    return assignStutus && competitor.status ? competitor.status : "-";
  }
}
